import { render } from "./DashboardHeaderDropdown.vue?vue&type=template&id=3721f2d1&scoped=true"
import script from "./DashboardHeaderDropdown.vue?vue&type=script&lang=js"
export * from "./DashboardHeaderDropdown.vue?vue&type=script&lang=js"

import "./DashboardHeaderDropdown.vue?vue&type=style&index=0&id=3721f2d1&scoped=true&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3721f2d1"]])

export default __exports__